import { useState, type ImgHTMLAttributes, type ReactNode } from 'react'

export type BrowserImageProps = ImgHTMLAttributes<HTMLImageElement> & {
  /** Rendered when the image fails to load (e.g. WebP on Safari < 14). */
  fallback?: ReactNode
}

/**
 * Image that hides itself (or shows fallback) when the browser cannot decode the format.
 */
export function BrowserImage({ fallback = null, onError, alt, ...props }: BrowserImageProps) {
  const [failed, setFailed] = useState(false)

  if (failed) {
    return <>{fallback}</>
  }

  return (
    <img
      alt={alt}
      {...props}
      onError={(event) => {
        setFailed(true)
        onError?.(event)
      }}
    />
  )
}
